var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowOutwardThin = function SvgArrowOutwardThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.365 7.435 5.7 19.1a.558.558 0 0 1-.395.172.54.54 0 0 1-.405-.172.552.552 0 0 1-.177-.4c0-.149.06-.282.177-.4L16.565 6.635H9.638a.556.556 0 0 1-.567-.572.555.555 0 0 1 .567-.562l8.14-.001c.205 0 .377.07.515.207.138.139.207.31.207.514v8.14c0 .161-.055.296-.165.405a.556.556 0 0 1-.407.163.555.555 0 0 1-.562-.567z"
  })));
};
export default SvgArrowOutwardThin;